// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__Rv8c0"};